import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock, faTimesCircle, faCheckCircle } from '@fortawesome/pro-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import { EnrolState } from 'enum'

interface IStateProps {
  state: number | undefined
  className?: string
  iconPosition?: string
}

const StateEnrol: React.FC<IStateProps> = ({ state, className = '', iconPosition = 'left' }) => {
  const { t } = useTranslation()
  const translateEnrolState = EnrolState[Number(state)].toLowerCase()
  const icon = () => {
    switch (Number(state)) {
      case EnrolState.Approved:
        return <FontAwesomeIcon icon={faCheckCircle} className="green mx-1" />
      case EnrolState.Denied:
        return <FontAwesomeIcon icon={faTimesCircle} className="red mx-1" />
      case EnrolState.Pending:
        return <FontAwesomeIcon icon={faClock} className="grey-light mx-1" />
    }
  }
  return (
    <small className={className}>
      {iconPosition === 'left' && icon()}
      <span> {t(`commons.enrols.state.${translateEnrolState}`)}</span>
      {iconPosition === 'right' && icon()}
    </small>
  )
}

export default StateEnrol
